export default "__VITE_ASSET__D7L8_3Ga__"